module.exports = __webpack_public_path__ + "static/media/23-9.8808e967.mp3";